import { AfterViewInit, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OverlayListenerOptions, OverlayOptions, TreeNode } from 'primeng/api';
import { TreeSelect } from 'primeng/treeselect';

@Component({
  standalone: false,
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'workflow-finx-treeselect',
  templateUrl: './workflow-finx-treeselect.component.html',
  styleUrls: ['./workflow-finx-treeselect.component.scss'],
})
export class WorkflowFinxTreeselectComponent implements AfterViewInit {
  @ViewChild('pTreeSelect') pTreeSelect: TreeSelect;

  @Output() selectedValueChange = new EventEmitter<TreeNode[] | TreeNode | null>();
  @Output() errorChange = new EventEmitter<string>();
  @Input() options: TreeNode[] = [];
  @Input() placeholder: string;
  @Input() error = '';
  @Input() class = '';
  @Input() isDisabled = false;
  @Input() appendto: string | HTMLElement;
  @Input() scrollHeight = '400px';
  @Input() selectedValue: TreeNode[] | TreeNode | null;
  @Input() selectionMode: 'single' | 'multiple' | 'checkbox' = 'single';

  ngAfterViewInit() {
    if (this.pTreeSelect && this.selectionMode !== 'single') {
      // Accessing internal property to prevent dropdown closure in multi-select mode
      (this.pTreeSelect as TreeSelect & { closeOnSelection: boolean }).closeOnSelection = false;
    }
  }

  onChange = (event: TreeNode[] | TreeNode) => {
    this.selectedValue = event;
    this.selectedValueChange.emit(this.selectedValue);
    this.error = '';
    this.errorChange.emit('');
  };

  getOverlayOptions(): OverlayOptions {
    return {
      listener: (event: Event, options?: OverlayListenerOptions) => {
        if (options?.type === 'scroll') {
          return false;
        }
        return options?.valid;
      },
    };
  }
}
